import React, { FC, memo } from 'react'

import IcArrowLeft from '@interco/icons/core/action-navigation/ic_arrow_left'
import { Text } from '@interco/inter-ui/components/Text'

import { HeaderContainer } from '../styles'
import { THeaderProps } from '../types'
import { HeaderRightIcon } from './HeaderRightIcon'
import { useHeader } from '../hooks'

export const Header: FC<THeaderProps> = memo(
  ({
    title,
    rightIcon,
    showHomeIcon,
    goToPath,
    ticScreen,
    homeIconRoute,
    leftIcon = true,
    leaveToApp = false,
    isHome = false,
    onClickLeftIcon,
  }) => {
    const { onReturnClickHandler, goTo } = useHeader({
      goToPath,
      ticScreen,
      homeIconRoute,
      leaveToApp,
      isHome,
    })

    return (
      <HeaderContainer $leftIcon={leftIcon}>
        {leftIcon && (
          <IcArrowLeft
            onClick={() => {
              if (onClickLeftIcon) onClickLeftIcon()
              onReturnClickHandler()
            }}
            color="var(--secondary500)"
            width={24}
            height={24}
          />
        )}
        <Text variant="headline-h3" semiBold>
          {title}
        </Text>
        {(rightIcon || leftIcon) && (
          <HeaderRightIcon goTo={goTo} rightIcon={rightIcon} showHomeIcon={showHomeIcon} />
        )}
      </HeaderContainer>
    )
  },
)
